/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import Canvas from './canvas';
import { pluckNumber, preDefStr, toRaphaelColor, pluck, canvasBorderColorStr,
  BGRATIOSTRING, COMMASTRING, dropHash, HASHSTRING, stubFN } from '../lib/lib';
import { convertColor, getDarkColor, getLightColor, getAngle } from '../lib/lib-graphics';
import { getDep, addDep } from '../dependency-manager';
import canvas3dAnimation from '../animation-rules/canvas3d-animation';
import raphaelShapesCubepath from '../redraphael/redraphael-shapes/redraphael-shapes.cubepath';

let R = getDep('redraphael', 'plugin'),
  canvasBaseColor3DStr = 'canvasBaseColor3D',
  canvasBGAlphaStr = 'canvasBgAlpha',
  clipCanvasStr = 'clip-canvas',
  clipCanvasInitStr = 'clip-canvas-init',
  COMMA = ',',
  MAX_MITER_LINEJOIN = 2,
  ROUND = preDefStr.ROUND,
  miterStr = preDefStr.miterStr,
  math = Math,
  mathMax = math.max,
  Raphael = R,
  NONE = 'none',
  M = 'M',
  L = 'L',
  Z = 'Z',
  V = 'V',
  chartPaletteStr = {
    chart2D: {
      bgColor: 'bgColor',
      bgAlpha: 'bgAlpha',
      bgAngle: 'bgAngle',
      bgRatio: 'bgRatio',
      canvasBgColor: 'canvasBgColor',
      canvasBaseColor: 'canvasBaseColor',
      divLineColor: 'divLineColor',
      legendBgColor: 'legendBgColor',
      legendBorderColor: 'legendBorderColor',
      toolTipbgColor: 'toolTipbgColor',
      toolTipBorderColor: 'toolTipBorderColor',
      baseFontColor: 'baseFontColor',
      anchorBgColor: 'anchorBgColor'
    },
    chart3D: {
      bgColor: 'bgColor3D',
      bgAlpha: 'bgAlpha3D',
      bgAngle: 'bgAngle3D',
      bgRatio: 'bgRatio3D',
      canvasBgColor: 'canvasBgColor3D',
      canvasBaseColor: canvasBaseColor3DStr,
      divLineColor: 'divLineColor3D',
      divLineAlpha: 'divLineAlpha3D',
      legendBgColor: 'legendBgColor3D',
      legendBorderColor: 'legendBorderColor3D',
      toolTipbgColor: 'toolTipbgColor3D',
      toolTipBorderColor: 'toolTipBorderColor3D',
      baseFontColor: 'baseFontColor3D',
      anchorBgColor: 'anchorBgColor3D'
    }
  },
  hideFn = function () {
    this.hide();
  },
  // for hiding cubepath
  hide3dBaseFn = function () {
    this.hide();
    this._.cubeside.hide();
    this._.cubetop.hide();
  },
  // for showing cubepath
  show3dBaseFn = function () {
    this.show();
    this._.cubeside.show();
    this._.cubetop.show();
  };

addDep({
  name: 'canvas3dAnimation',
  type: 'animationRule',
  extension: canvas3dAnimation
});

// Adding required shapes for chart.
raphaelShapesCubepath(R);

/**
 * Canvas is responsible for create the groups where the chart is going to render.
 * Canvas has also ability to add input buttons, all input components have to be added to
 * canvas to activate them. Ex. ZoomIn,ZoomOut etc Button in zoomscatter chart.
 * Before adding any input component to canvas it is required to attach axes to canvas,
 * so that input components can recognize what axis is zoomable or pannable.
 */
class Canvas3d extends Canvas {
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'canvas';
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'canvas';
  }
  /**
   * Draws canvas3d
   */
  drawCanvas () {
    if (this.getFromEnv('chart').isBar) {
      this.drawCanvas3dBar();
    } else {
      this.drawCanvas3dColumn();
    }
  }
  configureAttributes () {
    super.configureAttributes();
    this.config.xDepth = 10;
    this.config.yDepth = 10;
  }
  /**
   * Draws the 3d canvas for column
   */
  drawCanvas3dColumn () {
    var canvas = this,
      chart = canvas.getFromEnv('chart'),
      jsonData = chart.getFromEnv('dataSource'),
      canvasConfig = canvas.config,
      chartConfig = chart.config,
      canvasLeft = canvasConfig.canvasLeft,
      canvasTop = canvasConfig.canvasTop,
      canvasWidth = canvasConfig.canvasWidth,
      canvasHeight = canvasConfig.canvasHeight,
      chartAttrs = jsonData.chart,
      animationManager = canvas.getFromEnv('animationManager'),
      colorM = chart.getFromEnv('color-manager'),
      canvasBorderElementCheck = canvas.getGraphicalElement('canvasBorderElement'),
      canvasBorderElement,
      canvasElement,
      canvasElementCheck = canvas.getGraphicalElement('canvasElement'),
      config = canvas.config,
      clip = config.clip = { },
      canvasGroup = canvas.getContainer('canvasGroup'),
      canvasBg,
      canvasBgCheck = canvas.getGraphicalElement('canvasBg'),
      canvas3DBase,
      canvas3DBaseCheck = canvas.getGraphicalElement('canvas3DBase'),
      path,
      MAX_MITER_LINEJOIN = 2,
      attr,
      NONE = 'none',
      clipCanvasStr = 'clip-canvas',
      clipCanvasInitStr = 'clip-canvas-init',
      miterStr = preDefStr.miterStr,
      canvasBGAlphaStr = 'canvasBgAlpha',
      mathMax = Math.max,
      canvasBaseColor3DStr = 'canvasBaseColor3D',
      ROUND = preDefStr.ROUND,
      M = 'M',
      L = 'L',
      H = 'H',
      Z = 'Z',
      x,
      y,
      w,
      h,
      zw,
      zh,

      clipCanvas,
      dsGroup = chart.getChildContainer('plotGroup'),
      dataLabelsLayer = chart.getChildContainer('datalabelsGroup'),

      // animationObj = chart.get(configStr, animationObjStr),
      // animType = animationObj.animType,
      // animObj = animationObj.animObj,
      // dummyObj = animationObj.dummyObj,
      // animationDuration = animationObj.duration,

      canvas3dbaselineCheck = canvas.getGraphicalElement('canvas3dbaseline'),
      canvas3dbaseline,
      canvasBgColor = config.canvasBgColor,
      showCanvasBg = config.showCanvasBG = Boolean(pluckNumber(chartAttrs.showcanvasbg, 1)),
      canvasBgDepth = chartConfig.canvasBgDepth,
      showCanvasBase = chartConfig.showCanvasBase,
      canvasBaseDepth = chartConfig.canvasBaseDepth,
      canvasBaseColor3D = config.canvasBaseColor3D = pluck(chartAttrs.canvasbasecolor,
        colorM.getColor(canvasBaseColor3DStr)),
      use3DLighting = config.use3DLighting = pluckNumber(chartAttrs.use3dlighting, 1),

      palleteString = chartPaletteStr.chart3D,
      canvasBorderRadius = config.canvasBorderRadius = pluckNumber(chartAttrs.plotborderradius, 0),
      canvasBorderWidth = 0,
      borderWHlf = canvasBorderWidth * 0.5,
      canvasBorderColor = config.canvasBorderColor = convertColor(pluck(chartAttrs.canvasbordercolor,
        colorM.getColor(canvasBorderColorStr))),
      canBGAlpha = config.canBGAlpha = pluck(chartAttrs.canvasbgalpha, colorM.getColor(canvasBGAlphaStr)),
      canBGColor = config.canBGColor = pluck(chartAttrs.canvasbgcolor,
        colorM.getColor(palleteString.canvasBgColor)),
      xDepth,
      yDepth,
      // 2 px extra xDepth and yDepth in 3d chart's base
      canvasBasePadding = chartConfig.canvasBasePadding || 2;

    if (use3DLighting) {
      canvasBgColor = config.canvasBgColor = {
        FCcolor: {
          color: getDarkColor(canBGColor, 85) + COMMASTRING + getLightColor(canBGColor, 55),
          alpha: canBGAlpha + COMMASTRING + canBGAlpha,
          ratio: BGRATIOSTRING,
          angle: getAngle(chartConfig.width - (chartConfig.marginLeft + chartConfig.marginRight),
            chartConfig.height - (chartConfig.marginTop + chartConfig.marginBottom), 1)
        }
      };
    } else {
      canvasBgColor = config.canvasBgColor = convertColor(canBGColor, canBGAlpha);
    }

    canBGColor = canBGColor.split(COMMASTRING)[0];
    canBGAlpha = canBGAlpha.split(COMMASTRING)[0];

    xDepth = config.xDepth;
    yDepth = config.yDepth;

    attr = {
      x: canvasLeft - borderWHlf,
      y: canvasTop - borderWHlf,
      width: canvasWidth + canvasBorderWidth,
      height: canvasHeight + canvasBorderWidth,
      r: canvasBorderRadius,
      'stroke-width': canvasBorderWidth,
      stroke: canvasBorderColor,
      'stroke-linejoin': canvasBorderWidth > MAX_MITER_LINEJOIN ? ROUND : miterStr
    };

    canvasBorderElement = animationManager.setAnimation({
      el: canvasBorderElementCheck || 'rect',
      attr: attr,
      component: canvas,
      label: 'canvas',
      container: canvasGroup
    });
    if (!canvasBorderElementCheck) {
      canvas.addGraphicalElement('canvasBorderElement', canvasBorderElement);
    }

    // create a clip-rect to clip canvas for later use
    clip[clipCanvasStr] = [
      mathMax(0, canvasLeft - xDepth),
      mathMax(0, canvasTop),
      mathMax(1, canvasWidth + xDepth),
      mathMax(1, canvasHeight + yDepth)
    ];
    clip[clipCanvasInitStr] = [
      mathMax(0, canvasLeft - xDepth),
      mathMax(0, canvasTop - yDepth),
      1,
      mathMax(1, canvasHeight + yDepth * 2)
    ];

    clipCanvas = clip[clipCanvasStr].slice(0);
    animationManager.setAnimation({
      el: dsGroup,
      attr: {'clip-rect': clipCanvas},
      component: canvas
    });

    animationManager.setAnimation({
      el: dataLabelsLayer,
      attr: {'clip-rect': clipCanvas},
      component: canvas
    });

    attr = {
      x: canvasLeft,
      y: canvasTop,
      width: canvasWidth,
      height: canvasHeight,
      r: canvasBorderRadius,
      'stroke-width': 0,
      'stroke': NONE,
      fill: toRaphaelColor(canvasBgColor)
    };

    canvasElement = animationManager.setAnimation({
      el: canvasElementCheck || 'rect',
      attr: attr,
      component: canvas,
      label: 'canvas',
      callback: showCanvasBg ? stubFN : hideFn,
      container: canvasGroup
    });
    if (!canvasElementCheck) {
      canvas.addGraphicalElement('canvasElement', canvasElement);
    }

    path = [
      M, (canvasLeft + canvasWidth), canvasTop,
      L, (canvasLeft + canvasWidth + canvasBgDepth),
      (canvasTop + (canvasBgDepth * 1.2)),
      (canvasLeft + canvasWidth + canvasBgDepth),
      (canvasTop + canvasHeight - canvasBgDepth),
      (canvasLeft + canvasWidth), (canvasTop + canvasHeight),
      Z
    ];

    // Horizontal 3D Base
    canvasBg = animationManager.setAnimation({
      el: canvasBgCheck || 'path',
      attr: {
        'path': path,
        'stroke-width': 0,
        'stroke': NONE,
        fill: toRaphaelColor(canvasBgColor)
      },
      component: canvas,
      label: 'canvas',
      callback: showCanvasBg ? stubFN : hideFn,
      container: canvasGroup
    });
    if (!canvasBgCheck) {
      canvas.addGraphicalElement('canvasBg', canvasBg);
    }

    if (showCanvasBg) {
      canvasBg.show();
      canvasElement.show();
    } else {
      canvasBg.hide();
      canvasElement.hide();
    }

    x = canvasLeft - xDepth - canvasBasePadding;
    y = canvasTop + canvasHeight + yDepth + canvasBasePadding;
    w = canvasWidth;
    h = canvasBaseDepth;
    zw = xDepth + canvasBasePadding;
    zh = yDepth + canvasBasePadding;

    // if (!canvas3DBase) {
    canvas3DBase = animationManager.setAnimation({
      el: canvas3DBaseCheck || 'cubepath',
      component: canvas,
      index: 0,
      attr: {
        cubepath: [x, y, w, h, zw, zh],
        'stroke': NONE,
        'stroke-width': 0,
        'fill': canvasBaseColor3D.replace(dropHash, HASHSTRING),
        noGradient: !use3DLighting
      },
      callback: showCanvasBase ? stubFN : hide3dBaseFn,
      label: 'canvas',
      container: canvasGroup
    });

    if (!canvas3DBaseCheck) {
      canvas.addGraphicalElement('canvas3DBase', canvas3DBase);
    }

    canvas3dbaseline = animationManager.setAnimation({
      el: canvas3dbaselineCheck || 'path',
      attr: {
        'path': [M, canvasLeft, canvasTop + canvasHeight, H, canvasWidth + canvasLeft],
        stroke: R.tintshade(canvasBaseColor3D.replace(dropHash, HASHSTRING), 0.05).rgba
      },
      component: canvas,
      callback: showCanvasBase ? stubFN : hideFn,
      label: 'canvas',
      container: canvasGroup
    });
    if (!canvas3dbaselineCheck) {
      canvas.addGraphicalElement('canvas3dbaseline', canvas3dbaseline);
    }

    if (showCanvasBase) {
      show3dBaseFn.call(canvas3DBase);
      canvas3dbaseline.show();
    }
  }
  /**
   * Draws the 3d canvas for bar
   */
  drawCanvas3dBar () {
    var canvas = this,
      chart = canvas.getFromEnv('chart'),
      jsonData = chart.getFromEnv('dataSource'),
      chartConfig = chart.config,
      canvasLeft = chartConfig.canvasLeft,
      canvasTop = chartConfig.canvasTop,
      canvasWidth = chartConfig.canvasWidth,
      canvasHeight = chartConfig.canvasHeight,
      chartAttrs = jsonData.chart,
      colorM = chart.getFromEnv('color-manager'),
      canvasBorderElement,
      canvasBorderElementCheck = canvas.getGraphicalElement('canvasBorderElement'),
      canvasElementCheck = canvas.getGraphicalElement('canvasElement'),
      canvasElement,
      config = canvas.config,
      clip = config.clip = { },
      canvasGroup = canvas.getContainer('canvasGroup'),
      canvasBg,
      canvasBgCheck = canvas.getGraphicalElement('canvasBg'),
      canvas3DBase,
      canvas3DBaseCheck = canvas.getGraphicalElement('canvas3DBase'),
      attr,
      path,
      x,
      y,
      w,
      h,
      zw,
      zh,
      clipCanvas,
      dsGroup = chart.getChildContainer('plotGroup'),
      dataLabelsLayer = chart.getChildContainer('datalabelsGroup'),
      animationManager = canvas.getFromEnv('animationManager'),
      canvas3dbaseline,
      canvas3dbaselineCheck = canvas.getGraphicalElement('canvas3dbaseline'),
      canvasBgColor = config.canvasBgColor,
      showCanvasBg = config.showCanvasBG = Boolean(pluckNumber(chartAttrs.showcanvasbg, 1)),
      canvasBgDepth = chartConfig.canvasBgDepth,
      showCanvasBase = chartConfig.showCanvasBase,
      canvasBaseDepth = chartConfig.canvasBaseDepth,
      canvasBaseColor3D = config.canvasBaseColor3D = pluck(chartAttrs.canvasbasecolor,
        colorM.getColor(canvasBaseColor3DStr)),
      use3DLighting = config.use3DLighting = pluckNumber(chartAttrs.use3dlighting, 1),

      palleteString = chartPaletteStr.chart3D,
      canvasBorderRadius = config.canvasBorderRadius = pluckNumber(chartAttrs.plotborderradius, 0),
      canvasBorderWidth = config.canvasBorderWidth = 0,
      borderWHlf = canvasBorderWidth * 0.5,
      canvasBorderColor = config.canvasBorderColor = convertColor(pluck(chartAttrs.canvasbordercolor,
        colorM.getColor(canvasBorderColorStr))),
      canBGAlpha = config.canBGAlpha = pluck(chartAttrs.canvasbgalpha, colorM.getColor(canvasBGAlphaStr)),
      canBGColor = config.canBGColor = pluck(chartAttrs.canvasbgcolor,
        colorM.getColor(palleteString.canvasBgColor)),
      xDepth = config.xDepth,
      yDepth = config.yDepth;
    if (use3DLighting) {
      canvasBgColor = config.canvasBgColor = {
        FCcolor: {
          color: getDarkColor(canBGColor, 85) + COMMA + getLightColor(canBGColor, 55),
          alpha: canBGAlpha + COMMA + canBGAlpha,
          ratio: BGRATIOSTRING,
          angle: getAngle(chartConfig.width - (chartConfig.marginLeft + chartConfig.marginRight),
            chartConfig.height - (chartConfig.marginTop + chartConfig.marginBottom), 1)
        }
      };
    } else {
      canvasBgColor = config.canvasBgColor = convertColor(canBGColor, canBGAlpha);
    }

    canBGColor = canBGColor.split(COMMA)[0];
    canBGAlpha = canBGAlpha.split(COMMA)[0];

    xDepth = config.xDepth = 5;
    yDepth = config.yDepth = 5;

    attr = {
      x: canvasLeft - borderWHlf,
      y: canvasTop - borderWHlf,
      width: canvasWidth + canvasBorderWidth,
      height: canvasHeight + canvasBorderWidth,
      r: canvasBorderRadius,
      'stroke-width': canvasBorderWidth,
      stroke: canvasBorderColor,
      'stroke-linejoin': canvasBorderWidth > MAX_MITER_LINEJOIN ? ROUND : miterStr
    };

    canvasBorderElement = animationManager.setAnimation({
      el: canvasBorderElementCheck || 'rect',
      attr: attr,
      container: canvasGroup,
      label: 'canvas',
      component: canvas
    });
    if (!canvasBorderElementCheck) {
      canvas.addGraphicalElement('canvasBorderElement', canvasBorderElement);
    }

    // create a clip-rect to clip canvas for later use
    clip[clipCanvasStr] = [
      mathMax(0, canvasLeft - xDepth),
      mathMax(0, canvasTop),
      mathMax(1, canvasWidth + xDepth),
      mathMax(1, canvasHeight + yDepth)
    ];
    clip[clipCanvasInitStr] = [
      mathMax(0, canvasLeft - xDepth),
      mathMax(0, canvasTop - yDepth),
      1,
      mathMax(1, canvasHeight + yDepth * 2)
    ];

    clipCanvas = clip[clipCanvasStr].slice(0);
    animationManager.setAnimation({
      el: dsGroup,
      attr: {'clip-rect': clipCanvas},
      component: canvas
    });

    animationManager.setAnimation({
      el: dataLabelsLayer,
      attr: {'clip-rect': clipCanvas},
      component: canvas
    });

    attr = {
      x: canvasLeft,
      y: canvasTop,
      width: canvasWidth,
      height: canvasHeight,
      r: canvasBorderRadius,
      'stroke-width': 0,
      'stroke': NONE,
      fill: toRaphaelColor(canvasBgColor)
    };

    canvasElement = animationManager.setAnimation({
      el: canvasElementCheck || 'rect',
      attr: attr,
      component: canvas,
      label: 'canvas',
      container: canvasGroup
    });
    if (!canvasElementCheck) {
      canvas.addGraphicalElement('canvasElement', canvasElement);
    }

    // Vertical 3D Base
    path = [
      M, canvasLeft, canvasTop,
      L, (canvasLeft + (canvasBgDepth * 1.2)),
      (canvasTop - canvasBgDepth), (canvasLeft + canvasWidth - canvasBgDepth),
      (canvasTop - canvasBgDepth), (canvasLeft + canvasWidth), canvasTop,
      Z
    ];
    // if (!canvasBg) {
    canvasBg = animationManager.setAnimation({
      el: canvasBgCheck || 'path',
      attr: {
        'path': path,
        'stroke-width': 0,
        'stroke': NONE,
        fill: toRaphaelColor(canvasBgColor)
      },
      component: canvas,
      callback: showCanvasBg ? stubFN : hideFn,
      label: 'canvas',
      container: canvasGroup
    });
    if (!canvasBgCheck) {
      canvas.addGraphicalElement('canvasBg', canvasBg);
    }

    // Show canvas background if showCanvasBg is enabled
    if (showCanvasBg) {
      canvasElement.show();
      canvasBg.show();
    } else {
      canvasElement.hide();
      canvasBg.hide();
    }

    x = canvasLeft - xDepth - canvasBaseDepth - 1;
    y = canvasTop + yDepth + 1;
    w = canvasBaseDepth;
    h = canvasHeight;
    zw = xDepth + 1;
    zh = yDepth + 1;
    canvas3DBase = animationManager.setAnimation({
      el: canvas3DBaseCheck || 'cubepath',
      attr: {
        'cubepath': [x, y, w, h, zw, zh],
        'stroke': NONE,
        'stroke-width': 0,
        'fill': canvasBaseColor3D.replace(dropHash, HASHSTRING),
        noGradient: !use3DLighting
      },
      component: canvas,
      callback: showCanvasBase ? stubFN : hide3dBaseFn,
      label: 'canvas',
      container: canvasGroup
    });
    if (!canvas3DBaseCheck) {
      canvas.addGraphicalElement('canvas3DBase', canvas3DBase);
    }

    canvas3dbaseline = animationManager.setAnimation({
      el: canvas3dbaselineCheck || 'path',
      attr: {
        'path': [M, canvasLeft, canvasTop, V, canvasHeight + canvasTop],
        stroke: Raphael.tintshade(canvasBaseColor3D.replace(dropHash, HASHSTRING), 0.05).rgba
      },
      component: canvas,
      callback: showCanvasBase ? stubFN : hideFn,
      label: 'canvas',
      container: canvasGroup
    });
    if (!canvas3dbaselineCheck) {
      canvas.addGraphicalElement('canvas3dbaseline', canvas3dbaseline);
    }

    // Show canvas base if showCanvasBase is enabled
    if (showCanvasBase) {
      canvas3dbaseline.show();
      show3dBaseFn.call(canvas3DBase);
    }
  }
}

export default Canvas3d;
